"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const ConsentStore_1 = require("../../stores/ConsentStore");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const NotFound_1 = __importDefault(require("../NotFound"));
const StoresUtil_1 = require("../../util/StoresUtil");
const ApiUtil_1 = __importDefault(require("../../util/ApiUtil"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const PartyPrivacyProfileStore_1 = require("../../stores/PartyPrivacyProfileStore");
let GDPRChoiceDetail = class GDPRChoiceDetail extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "downloadFailed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "shouldShowDownloadButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, agreement) => {
                const isNotBusinessCustomerDirectMarketing = type !== ConsentStore_1.ConsentType.DIRECT_MARKETING || this.ssoStore.isPrivateCustomer;
                return isNotBusinessCustomerDirectMarketing && !!(agreement === null || agreement === void 0 ? void 0 : agreement.id);
            }
        });
        Object.defineProperty(this, "handleDocumentResponse", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                const contentDisposition = response.headers['content-disposition'];
                const filenameIndex = contentDisposition === null || contentDisposition === void 0 ? void 0 : contentDisposition.indexOf('filename=');
                if (filenameIndex === -1 || filenameIndex === undefined) {
                    this.flashTechnicalError();
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                const filename = contentDisposition.substring(filenameIndex).split('=')[1];
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }
        });
        Object.defineProperty(this, "flashTechnicalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.downloadFailed = true;
                setTimeout((0, mobx_1.action)(() => (this.downloadFailed = false)), 5000);
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { type } = this.props;
        const { translate } = this.translateStore;
        let content;
        let subtitle;
        let agreement;
        switch (type) {
            case ConsentStore_1.ConsentType.TRAFFIC_DATA_ANALYSIS:
                content = translate('gdpr.trafficDataChoiceDetails');
                agreement = this.partyPrivacyProfileStore.getAgreement(PartyPrivacyProfileStore_1.AgreementType.TRAFFIC_DATA_ANALYSIS);
                subtitle = translate('gdpr.personalMarketingHeader');
                break;
            case ConsentStore_1.ConsentType.LOCATION_DATA_ANALYSIS:
                content = translate('gdpr.locationDataChoiceDetails');
                agreement = this.partyPrivacyProfileStore.getAgreement(PartyPrivacyProfileStore_1.AgreementType.LOCATION_DATA_ANALYSIS);
                subtitle = translate('gdpr.personalMarketingHeader');
                break;
            case ConsentStore_1.ConsentType.DIRECT_MARKETING:
                content = translate('gdpr.directMarketingChoiceDetails');
                agreement = this.partyPrivacyProfileStore.getAgreement(PartyPrivacyProfileStore_1.AgreementType.DIRECT_MARKETING);
                subtitle = translate('gdpr.directMarketingOffers');
                break;
            default:
                console.error(`No consent with type ${type} found`);
        }
        if (!content) {
            return react_1.default.createElement(NotFound_1.default, null);
        }
        return (react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-6'] },
                react_1.default.createElement(lib_1.Text, { className: "text-center" },
                    react_1.default.createElement(lib_1.Heading, { className: "h2" }, translate('gdpr.details.title')),
                    react_1.default.createElement("p", { className: "h4" }, subtitle),
                    this.shouldShowDownloadButton(type, agreement) && (react_1.default.createElement(GaButton_1.default, { id: "gdpr-choice-detail-download-pdf", text: translate('gdpr.download.pdf'), iconLeft: "#download", link: true, onClick: () => {
                            ApiUtil_1.default.get(`/privacy-agreement/${agreement.id}/document`, { responseType: 'blob' })
                                .then(this.handleDocumentResponse)
                                .catch(this.flashTechnicalError);
                        } })),
                    this.downloadFailed && react_1.default.createElement(lib_1.Notice, { type: "attention" }, translate('global.server.error')),
                    react_1.default.createElement("div", { className: "text text-left text__margin-double", dangerouslySetInnerHTML: { __html: content } })))));
    }
};
__decorate([
    mobx_1.observable
], GDPRChoiceDetail.prototype, "downloadFailed", void 0);
__decorate([
    mobx_1.action
], GDPRChoiceDetail.prototype, "flashTechnicalError", void 0);
GDPRChoiceDetail = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRChoiceDetail);
exports.default = GDPRChoiceDetail;
